import { render } from "./GroupsMain.vue?vue&type=template&id=7ecb0d40"
import script from "./GroupsMain.vue?vue&type=script&lang=js"
export * from "./GroupsMain.vue?vue&type=script&lang=js"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__